import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiAlertCircle, FiCheck, FiX } from 'react-icons/fi';

const StatusConfirmationModal = ({ isOpen, onClose, onConfirm, itemName, currentStatus }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          className="bg-white rounded-xl shadow-xl max-w-md w-full overflow-hidden"
          onClick={e => e.stopPropagation()}
        >
          {/* Decorative top border */}
          <div className={`h-1 w-full ${currentStatus ? 'bg-red-500' : 'bg-green-500'}`} />
          
          <div className="p-6">
            <div className="flex items-start gap-4">
              <div className={`p-2 rounded-full ${currentStatus ? 'bg-red-100' : 'bg-green-100'}`}>
                <FiAlertCircle className={`w-6 h-6 ${currentStatus ? 'text-red-600' : 'text-green-600'}`} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  {currentStatus ? 'Deactivate' : 'Activate'} {itemName}
                </h3>
                <p className="mt-2 text-sm text-gray-500">
                  Are you sure you want to {currentStatus ? 'deactivate' : 'activate'} this {itemName.toLowerCase()}? 
                  {currentStatus 
                    ? ' This will hide it from the main application.'
                    : ' This will make it visible in the main application.'}
                </p>
              </div>
            </div>

            <div className="mt-6 flex gap-3 justify-end">
              <button
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                className={`px-4 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                  currentStatus 
                    ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500'
                    : 'bg-green-600 hover:bg-green-700 focus:ring-green-500'
                }`}
              >
                {currentStatus ? 'Deactivate' : 'Activate'}
              </button>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default StatusConfirmationModal;